import React, { Fragment } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { Button, Icon } from './';


type Props = {
    btnLabel: string,
    disabled?: boolean,
    btnBadge?: number, //number to display as badge on button
    smallContainer?: boolean,
    icon?: any,
    extraSmall?: boolean,
    content: any | ((close: () => void) => React.ReactNode),
    panelPosition?: 'left' | 'right',
    panelWidthClassName?: string,
};

export const Dropdown: (props: Props) => JSX.Element =
    ({
         btnLabel,
         disabled,
         btnBadge,
         smallContainer,
         icon,
         extraSmall,
         content,
         panelPosition,
         panelWidthClassName
     }) => {

        return (
            <Popover className="relative">
                {({ open, close }) => (
                    <>
                        <Popover.Button as="div" className="">
                            <Button
                                badge={btnBadge}
                                noShadow={true}
                                disabled={disabled}
                                color="transparent"
                                icon={<Icon type="arrow" className={open ? 'rotate-180' : ''} />}
                                iconAfter={true}
                                label={btnLabel}
                                extraSmall={extraSmall}
                                onClick={() => {}}
                            />
                        </Popover.Button>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                        >
                            <Popover.Panel
                                className={`${smallContainer ? '' : 'w-screen'} absolute ${panelPosition === 'left' ? 'left-0' : 'right-0'} z-10 mt-3 -translate-x-1 transform px-4 sm:px-0 ${panelWidthClassName || 'max-w-sm lg:max-w-2xl'}`}>
                                <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black/5">
                                    <div className="relative bg-white p-6">
                                        {typeof content === 'function' ? content(close) : content}
                                    </div>
                                </div>
                            </Popover.Panel>
                        </Transition>
                    </>
                )}
            </Popover>
        );
    };
